import React, { useState, useEffect } from 'react'
import { ModalButton } from 'src/components/Global/Button/Button'
import { useDispatch } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { CardWrapper } from './cardSettingsStyle'
import { getMyCardsAction, addMyCardAction } from 'src/redux/actions/cards'
import { useTypedSelector } from 'src/redux/root-reducer'
import { splitCardDigits } from 'src/utils/cards'
import { usePaystack } from 'src/utils/paystack'
import useUserData from 'src/hooks/useUserData'
import { MasterSvg, VisaSvg, VerveSvg, CardArrowSvg } from 'src/assets/index'
import { Spinner } from 'src/components/Global/Spinner/Spinner'
import useSnackbar from 'src/hooks/useSnackBar'
import { VaultSvg } from 'src/assets'
import { action } from 'typesafe-actions'
import { CardTypes } from 'src/redux/types/cards'

// const PATH: any = []
const CardSettings = () => {
  const dispatch = useDispatch()

  const { pay } = usePaystack()
  const USER_DATA = useUserData()

  const user_email = USER_DATA.user.email

  let location = useLocation()

  const [loading, setLoading] = useState(false)

  const cardsResult = useTypedSelector((state) => state.cards?.myCards?.cards)
  console.log(cardsResult)

  const CardImage = (card_type: any) => {
    if (card_type === 'visa') {
      return VisaSvg
    } else if (card_type === 'Mastercard') {
      return MasterSvg
    } else if (card_type === 'verve') {
      return VerveSvg
    }
  }

  const itemId = cardsResult ? cardsResult[0] : null
  console.log(itemId)
  const [id, setId] = useState()

  const snackbar = useSnackbar()

  const handleAddCard = () => {
    setLoading(true)
    dispatch(addMyCardAction({ onAddSuccess, onAddError }))
  }

  const onAddSuccess = (message: string) => {
    console.log(message)
    setLoading(false)
    const payload = {
      reference: message,
      email: user_email,
      amount: 100 * 100,
    }
    const onPaySuccess = () => {
      dispatch(getMyCardsAction())
      snackbar.trigger({
        message: 'Card added successfully',
        severity: 'success',
      })
    }
    const onClose = () => {
      console.log('error')
    }

    pay(payload, onPaySuccess, onClose)
  }

  const onAddError = (msg: any) => {
    setLoading(false)
    snackbar.trigger({
      message: msg,
      severity: 'error',
    })
  }

  return (
    <CardWrapper>
      <h1>Cards Settings</h1>
      <p className="manage_text">Manage all connected debit cards here.</p>
      <div className="cards">
        {cardsResult?.length !== undefined ? (
          cardsResult?.map((item: any) => {
            const {
              card_prefix,
              card_suffix,
              expiry_month,
              expiry_year,
              card_type,
              id,
            } = item
            console.log(card_type)
            return (
              <div className="debit_card_container">
                <Link
                  to={`/card/${id}`}
                  key={id}
                  state={{ backgroundLocation: location }}
                  className="card_link"
                >
                  <div
                    className="debit_card_wrapper"
                    key={id}
                    onClick={(e) => {
                      setId(id)
                    }}
                  >
                    <div className="debit_card">
                      <div className="card_img_wrapper">
                        <img
                          src={`${CardImage(card_type)}`}
                          className="card_img"
                          alt=""
                        />
                      </div>
                      <div className="card_num_date">
                        <p className="card_num">
                          {splitCardDigits(card_prefix, card_suffix)}
                        </p>
                        <p className="card_date">
                          {expiry_month}/{expiry_year}
                        </p>
                      </div>
                    </div>
                    <div className="card_arrow">
                      <img src={CardArrowSvg} alt="" className="" />
                    </div>
                  </div>
                </Link>
              </div>
            )
          })
        ) : (
          <div className="no_card_wrapper">
            <img src={VaultSvg} alt="" className="no_card_img" />
            <p>Your card section looks empty</p>
          </div>
        )}
      </div>

      <div className="link-btn">
        <ModalButton className="confirm" onClick={handleAddCard}>
          Add New Card {loading && <Spinner />}
        </ModalButton>
      </div>
    </CardWrapper>
  )
}

export { CardSettings }
